<template>
  <div class="member-invite-enter-code">
    <cookies-disabled-error v-if="cookiesDisabledError" class="error-holder" />
    <invite-member-already-exists-error v-else-if="memberAlreadyExists" :phone-number="phoneNumber" :inviter="primaryMemberDetails.firstName" />
    <div v-else>
      <img class="image-container" :src="require('@/assets/hero-login.svg')">
      <div class="content">
        <enter-code class="enter-code"
                    :first-name="firstName"
                    :phone-number="phoneNumber"
                    :confirm-code-action="createMemberAndProceed"
                    :regenerate-code-action="forceGenerateCode"
                    :server-error="errors.createMember"
                    :button-title="'אישור'"
                    :loading="loading"
                    :reset-error="() => resetError('createMember')"/>
        <login-support-footer :link-action="openLoginHelpModal" />
      </div>
    </div>
  </div>
</template>

<script>
import { mapMutations, mapActions, mapState, mapGetters } from 'vuex';
import BaseUI from 'base-ui';
import InviteMemberAlreadyExistsError
  from '@/pages/responsive-pages/invite-authenticated/member-invite/pages/InviteMemberAlreadyExistsError';
import CookiesDisabledError from '@/pages/general-errors/CookiesDisabledError.vue';
import Segment from '@/Segment';
import EnterCode from '@/base-components/EnterCode.vue';
import ModalBus from '@/event-bus/modal-bus';
import LoginHelp from '@/pages/responsive-pages/non-authenticated/login/steps/LoginHelp';

export default {
  name: 'MemberInviteEnterCode',
  components: {
    InviteMemberAlreadyExistsError,
    EnterCode,
    CookiesDisabledError,
    LoginSupportFooter: BaseUI.LoginSupportFooter,
  },
  data() {
    return {
      loading: false,
    };
  },
  props: {
    next: {
      type: Function,
      required: true,
    },
  },
  async created() {
    Segment.trackUserGot('MemberInviteEnterCodeEntered');
  },
  computed: {
    ...mapState('memberInvite', ['firstName', 'lastName', 'phoneNumber', 'errors']),
    ...mapGetters('memberInvite', ['inviteMemberFlowSteps', 'errorTypes']),
    ...mapState('inviteSession', ['primaryMemberDetails']),
    memberAlreadyExists() {
      return this.errors.createMember === this.errorTypes.memberAlreadyExists;
    },
    cookiesDisabledError() {
      return this.errors.createMember === this.errorTypes.cookiesDisabled;
    },
  },
  methods: {
    ...mapMutations('memberInvite', ['resetError']),
    ...mapActions('memberInvite', ['createMember', 'forceGenerateCode']),
    async createMemberAndProceed() {
      try {
        this.loading = true;
        await this.createMember();
        this.next();
      } finally {
        this.loading = false;
      }
    },
    openLoginHelpModal() {
      ModalBus.$emit('open', {
        component: LoginHelp,
      });
    },
  },
};
</script>
<style lang="scss" scoped>
  @import 'src/scss/mixins';

  .error-holder {
    margin: 30px;
  }

  .member-invite-enter-code {
    width: 100%;

    .image-container {
      width: 100%;
    }

    .content {
      margin: 30px;
    }

    .enter-code {
      @include responsive-padding;
      width: 100%;
    }
  }

</style>
